/**
 * Created by pzf on 2018/11/29
 *
 */
export var BUILT_IN_PLACEMENTS = {
  bottomLeft: {
    points: ['tl', 'bl'],
    offset: [0, 4]
  },
  topLeft: {
    points: ['bl', 'tl'],
    offset: [0, -4]
  },
  bottomRight: {
    points: ['tr', 'br'],
    offset: [0, 4]
  },
  topRight: {
    points: ['br', 'tr'],
    offset: [0, -4]
  }
};
export var POPUP_ALIGN = {
  overflow: {
    adjustX: 1,
    adjustY: 1
  }
};
export var POPUP_PLACEMENT = 'bottomLeft';
//# sourceMappingURL=constant.js.map
